import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Typography
} from '@mui/material';
import { parseHtmlString } from 'components/common/RichTextEditor/richTextParseToMui';
import { staticContent } from 'components/constants/Constants';
import { TrendsAndScienceCategory } from 'portals/types';
import React from 'react';
import { Link } from 'react-router-dom';

export const TrendsScienceCard: React.FC<{
  card: {
    title: string;
    image: string;
    description: string;
    link: string;
    category?: TrendsAndScienceCategory;
  };
}> = ({ card }) => {
  return (
    <Card sx={{ p: 4 }}>
      <CardMedia
        component="img"
        image={`${staticContent}/${card.image}`}
        alt={card.title}
        height={'280'}
      />
      <Box sx={{ py: 1 }}>
        <Typography variant="caption" sx={{ textTransform: 'uppercase' }}>
          {card.category ?? TrendsAndScienceCategory.TRENDS}
        </Typography>
        <Typography variant="h3">{card.title}</Typography>
      </Box>
      <CardContent sx={{ p: 0 }}>
        {parseHtmlString(card.description, 'body1')}
      </CardContent>
      <Button
        sx={{ mt: 2 }}
        component={Link}
        to={card.link}
        variant="outlined"
        target="_blank"
      >
        View more
      </Button>
    </Card>
  );
};
